module.exports = __webpack_public_path__ + "assets/img/image-57-1280.6aeb0418.webp";